const initialState = [];

const statusReducer = (state = initialState, action) => {
    switch (action.type) {
        case "STATUSES":
            return (state = action.payload);
        default:
            return state;
    }
};


export default statusReducer;